export default __webpack_public_path__ + "static/irbis-4040cabc779f43c8775ad124aadf5ea7.png";